import {
    apiRequest,
    employeeWFHDetail,
    employeeWFHReport,
    employeeWFHReportSend,
    getAtasan,
} from "../../../../../services/adapters/kepegawaian/employeeWFHService"

class ReportRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", employeeWFHDetail, {
            params: query
        }, true)
    }
    fetchAtasan = async (query) => {
        return await apiRequest("get", getAtasan, {
            params: query
        }, true)
    }

    fetchReport = async (query) => {
        return await apiRequest("post", employeeWFHReport, {
            body: query
        }, true)
    }

    fetchReportSend = async (query) => {
        return await apiRequest("post", employeeWFHReportSend, {
            body: query
        }, true)
    }
}

export default ReportRepository